import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import translation from "~/translations";
import i18next from "i18next";


// Assets
import NewLandingLayout from "~/layouts/LandingLayout";
import "~/assets/sass/pages/landing/case/index.scss";
import PriceImg from '~/assets/img/defaultImg/price.png';

const PricePage = () => {


    return (
        <NewLandingLayout>
            <div className="p__price">
                <div className="vc-section">
                    <div className="l__layout">
                        <div className="price_section">
                            <div className="price_top">
                                <h3 className={"title"}>요금안내</h3>
                                <div className={"type"}>월간</div>
                            </div>
                            <img src={PriceImg} />
                        </div>
                    </div>
                </div>
            </div>
        </NewLandingLayout>
    );
};

export default PricePage;
